const mockData = [
  {
    application_id: '12345678-ABCD-1234-ABCD-1234567890AB',
    applicant_names: [
      {
        first_name: "John",
        last_name: "Doe",
      },
    ],
    user: '98765432-DCBA-4321-DCBA-0987654321BA',
    ms_property_id: '567890AB-CD12-3456-ABCD-7890123456EF',
    property_name: 'ICO - Multifamily - Pleasant Grove T/Homes',
    property_unit_number: 'A102',
    status: 'pending',
    screening_status: 'Not Started',
    submitted_at: '2024-11-22T12:00:00.000Z',
    payment_received: true,
    app_data: {
      application_id: '12345678-ABCD-1234-ABCD-1234567890AB',
      email: 'johndoe@example.com',
      desired_property_id: '567890AB-CD12-3456-ABCD-7890123456EF',
      desired_apartment: 'A102',
      desired_lease_term: 12,
      leasing_agent: 'Alice Smith',
      desired_move_in_date: '2025-01-15T08:00:00.000Z',
      referral_source: 'website',
      first_name: 'John',
      last_name: 'Doe',
      phone_number: '5554446666',
      dob: '1990-02-10T08:00:00.000Z',
      other_names: 'Johnny',
      other_adults_count: 1,
      current_residence_rental: true,
      current_residence_address: '456 Elm Street',
      current_residence_unit: '300',
      current_residence_city: 'Portland',
      current_residence_state: 'OR',
      current_residence_zip: '97201',
      current_residence_rent: '1800',
      current_residence_reason_for_leaving: 'job relocation',
      current_residence_landlord_name: 'Oakwood Properties',
      current_residence_landlord_phone: '5557778888',
      current_residence_start_date: '2019-06-01T07:00:00.000Z',
      other_residence_rental: false,
      other_residence_address: '',
      other_residence_unit: '',
      other_residence_city: '',
      other_residence_state: '',
      other_residence_zip: '',
      other_residence_rent: '',
      other_residence_reason_for_leaving: '',
      other_residence_landlord_name: '',
      other_residence_landlord_phone: '',
      other_residence_start_date: null,
      emergency_contact_name: 'Jane Doe',
      emergency_contact_phone: '5558889999',
      emergency_contact_relationship: 'Sister',
      emergency_contact2_name: 'Mike Brown',
      emergency_contact2_phone: '5559991111',
      emergency_contact2_relationship: 'Friend',
      misc_smoker: false,
      misc_marital_status: 'Single',
      misc_addl_info: true,
      misc_has_facebook_profile: true,
      misc_crimes: false,
      misc_crimes_details: '',
      misc_bankruptcy: false,
      misc_bankruptcy_details: '',
      misc_legal_residents: true,
      user: '98765432-DCBA-4321-DCBA-0987654321BA',
      children: ['Emily Doe'],
      vehicles: [
        {
          make: 'Toyota',
          model: 'Camry',
          year: 2020,
          license_plate: 'ABC123'
        }
      ],
      pets: [
        {
          type: 'Dog',
          breed: 'Golden Retriever',
          name: 'Buddy'
        }
      ]
    },
    application_group: 'GROUP001',
    desired_apartment: 'A102',
    desired_lease_term: 12,
    desired_move_in_date: '2025-01-15T08:00:00.000Z'
  },
  {
    application_id: '22334455-DEFG-2233-DEFG-223344556677',
    applicant_names: [
      {
        first_name: "Jane",
        last_name: "Doe",
      },
    ],
    user: '11223344-CCBB-1122-CCBB-112233445566',
    ms_property_id: '567890AB-CD12-3456-ABCD-7890123456EF',
    property_name: 'ICO - Multifamily - Pleasant Grove T/Homes',
    property_unit_number: 'A102',
    status: 'pending',
    screening_status: 'Not Started',
    submitted_at: '2024-11-22T12:30:00.000Z',
    payment_received: false,
    app_data: {
      application_id: '22334455-DEFG-2233-DEFG-223344556677',
      email: 'janedoe@example.com',
      desired_property_id: '567890AB-CD12-3456-ABCD-7890123456EF',
      desired_apartment: 'A102',
      desired_lease_term: 12,
      leasing_agent: 'Alice Smith',
      desired_move_in_date: '2025-01-15T08:00:00.000Z',
      referral_source: 'social_media',
      first_name: 'Jane',
      last_name: 'Doe',
      phone_number: '5555556666',
      dob: '1992-03-15T08:00:00.000Z',
      other_names: '',
      other_adults_count: 0,
      current_residence_rental: true,
      current_residence_address: '123 Pine St',
      current_residence_unit: '2A',
      current_residence_city: 'Seattle',
      current_residence_state: 'WA',
      current_residence_zip: '98101',
      current_residence_rent: '2000',
      current_residence_reason_for_leaving: 'relocation',
      current_residence_landlord_name: 'Pine Rentals',
      current_residence_landlord_phone: '5557778899',
      current_residence_start_date: '2020-01-01T07:00:00.000Z',
      other_residence_rental: false,
      other_residence_address: '',
      other_residence_unit: '',
      other_residence_city: '',
      other_residence_state: '',
      other_residence_zip: '',
      other_residence_rent: '',
      other_residence_reason_for_leaving: '',
      other_residence_landlord_name: '',
      other_residence_landlord_phone: '',
      other_residence_start_date: null,
      emergency_contact_name: 'Emily Doe',
      emergency_contact_phone: '5556677888',
      emergency_contact_relationship: 'Sister',
      emergency_contact2_name: 'Lisa Ray',
      emergency_contact2_phone: '5559988777',
      emergency_contact2_relationship: 'Friend',
      misc_smoker: false,
      misc_marital_status: 'Married',
      misc_addl_info: false,
      misc_has_facebook_profile: true,
      misc_crimes: false,
      misc_crimes_details: '',
      misc_bankruptcy: false,
      misc_bankruptcy_details: '',
      misc_legal_residents: true,
      user: '11223344-CCBB-1122-CCBB-112233445566',
      children: [],
      vehicles: [],
      pets: []
    },
    application_group: 'GROUP001',
    desired_apartment: 'A102',
    desired_lease_term: 12,
    desired_move_in_date: '2025-01-15T08:00:00.000Z'
  },
  {
    application_id: '33334444-HIJK-3344-HIJK-333344445555',
    applicant_names: [
      {
        first_name: "Robert",
        last_name: "Jones",
      },
    ],
    user: '66778899-KLMN-7788-KLMN-667788990000',
    ms_property_id: '78901234-EFGH-5678-EFGH-789012345678',
    property_name: 'ICO FOrt Union',
    property_unit_number: 'B305',
    status: 'completed',
    screening_status: 'Completed',
    submitted_at: '2024-11-20T10:00:00.000Z',
    payment_received: true,
    app_data: {
      application_id: '33334444-HIJK-3344-HIJK-333344445555',
      email: 'robert.jones@example.com',
      desired_property_id: '78901234-EFGH-5678-EFGH-789012345678',
      desired_apartment: 'B305',
      desired_lease_term: 6,
      leasing_agent: 'Bob Carter',
      desired_move_in_date: '2024-12-20T08:00:00.000Z',
      referral_source: 'flyer',
      first_name: 'Robert',
      last_name: 'Jones',
      phone_number: '5556667777',
      dob: '1985-08-22T08:00:00.000Z',
      other_names: '',
      other_adults_count: 0,
      current_residence_rental: true,
      current_residence_address: '321 Oak St',
      current_residence_unit: '12B',
      current_residence_city: 'San Francisco',
      current_residence_state: 'CA',
      current_residence_zip: '94101',
      current_residence_rent: '3000',
      current_residence_reason_for_leaving: 'downsizing',
      current_residence_landlord_name: 'Oakwood Properties',
      current_residence_landlord_phone: '5556677788',
      current_residence_start_date: '2018-07-01T07:00:00.000Z',
      other_residence_rental: false,
      other_residence_address: '',
      other_residence_unit: '',
      other_residence_city: '',
      other_residence_state: '',
      other_residence_zip: '',
      other_residence_rent: '',
      other_residence_reason_for_leaving: '',
      other_residence_landlord_name: '',
      other_residence_landlord_phone: '',
      other_residence_start_date: null,
      emergency_contact_name: 'Laura Jones',
      emergency_contact_phone: '5559977555',
      emergency_contact_relationship: 'Spouse',
      emergency_contact2_name: '',
      emergency_contact2_phone: '',
      emergency_contact2_relationship: '',
      misc_smoker: false,
      misc_marital_status: 'Married',
      misc_addl_info: true,
      misc_has_facebook_profile: true,
      misc_crimes: false,
      misc_crimes_details: '',
      misc_bankruptcy: false,
      misc_bankruptcy_details: '',
      misc_legal_residents: true,
      user: '66778899-KLMN-7788-KLMN-667788990000',
      children: ['Sarah Jones', 'Tim Jones'],
      vehicles: [
        {
          make: 'Honda',
          model: 'Civic',
          year: 2018,
          license_plate: 'DEF456'
        },
        {
          make: 'Tesla',
          model: 'Model 3',
          year: 2021,
          license_plate: 'GHI789'
        }
      ],
      pets: []
    },
    application_group: 'GROUP002',
    desired_apartment: 'B305',
    desired_lease_term: 6,
    desired_move_in_date: '2024-12-20T08:00:00.000Z'
  },
  {
    application_id: '33344444-HIJK-3344-HIJK-333344445555',
    applicant_names: [
      {
        first_name: "Bean",
        last_name: "David",
      },
    ],
    user: '66778899-KLMN-7788-KLMN-667788990000',
    ms_property_id: '78901234-EFGH-5678-EFGH-789012345678',
    property_name: 'ICO - Multifamily - Pleasant Grove T/Homes',
    property_unit_number: 'B306',
    status: 'denied',
    screening_status: 'Completed',
    submitted_at: '2024-11-20T10:00:00.000Z',
    payment_received: true,
    app_data: {
      application_id: '33344444-HIJK-3344-HIJK-333344445555',
      email: 'robert.jones@example.com',
      desired_property_id: '78901234-EFGH-5678-EFGH-789012345678',
      desired_apartment: 'B306',
      desired_lease_term: 6,
      leasing_agent: 'Bob Carter',
      desired_move_in_date: '2024-12-20T08:00:00.000Z',
      referral_source: 'flyer',
      first_name: 'Bean',
      last_name: 'David',
      phone_number: '5556667777',
      dob: '1985-08-22T08:00:00.000Z',
      other_names: '',
      other_adults_count: 0,
      current_residence_rental: true,
      current_residence_address: '321 Oak St',
      current_residence_unit: '12B',
      current_residence_city: 'San Francisco',
      current_residence_state: 'CA',
      current_residence_zip: '94101',
      current_residence_rent: '3000',
      current_residence_reason_for_leaving: 'downsizing',
      current_residence_landlord_name: 'Oakwood Properties',
      current_residence_landlord_phone: '5556677788',
      current_residence_start_date: '2018-07-01T07:00:00.000Z',
      other_residence_rental: false,
      other_residence_address: '',
      other_residence_unit: '',
      other_residence_city: '',
      other_residence_state: '',
      other_residence_zip: '',
      other_residence_rent: '',
      other_residence_reason_for_leaving: '',
      other_residence_landlord_name: '',
      other_residence_landlord_phone: '',
      other_residence_start_date: null,
      emergency_contact_name: 'Laura Jones',
      emergency_contact_phone: '5559977555',
      emergency_contact_relationship: 'Spouse',
      emergency_contact2_name: '',
      emergency_contact2_phone: '',
      emergency_contact2_relationship: '',
      misc_smoker: false,
      misc_marital_status: 'Married',
      misc_addl_info: true,
      misc_has_facebook_profile: true,
      misc_crimes: false,
      misc_crimes_details: '',
      misc_bankruptcy: false,
      misc_bankruptcy_details: '',
      misc_legal_residents: true,
      user: '66778899-KLMN-7788-KLMN-667788990000',
      children: ['Sarah Jones', 'Tim Jones'],
      vehicles: [
        {
          make: 'Honda',
          model: 'Civic',
          year: 2018,
          license_plate: 'DEF456'
        },
        {
          make: 'Tesla',
          model: 'Model 3',
          year: 2021,
          license_plate: 'GHI789'
        }
      ],
      pets: []
    },
    application_group: 'GROUP003',
    desired_apartment: 'B306',
    desired_lease_term: 6,
    desired_move_in_date: '2024-12-20T08:00:00.000Z'
  },
  {
    application_id: '44445566-OPQR-4455-OPQR-444455667788',
    applicant_names: [
      {
        first_name: "Michael",
        last_name: "Smith",
      },
    ],
    user: '33445566-ZZYY-3344-ZZYY-334455667788',
    ms_property_id: '567890AB-CD12-3456-ABCD-7890123456EF',
    property_name: 'ICO Fort Union',
    property_unit_number: 'A102',
    status: 'pending',
    screening_status: 'Not Started',
    submitted_at: '2024-11-22T13:00:00.000Z',
    payment_received: false,
    app_data: {
      application_id: '44445566-OPQR-4455-OPQR-444455667788',
      email: 'michael.smith@example.com',
      desired_property_id: '567890AB-CD12-3456-ABCD-7890123456EF',
      desired_apartment: 'A102',
      desired_lease_term: 12,
      leasing_agent: 'Alice Smith',
      desired_move_in_date: '2025-01-15T08:00:00.000Z',
      referral_source: 'agent referral',
      first_name: 'Michael',
      last_name: 'Smith',
      phone_number: '5553332222',
      dob: '1988-07-20T08:00:00.000Z',
      other_names: '',
      other_adults_count: 1,
      current_residence_rental: true,
      current_residence_address: '789 Maple Avenue',
      current_residence_unit: '4C',
      current_residence_city: 'Portland',
      current_residence_state: 'OR',
      current_residence_zip: '97202',
      current_residence_rent: '1900',
      current_residence_reason_for_leaving: 'upgrading to a larger apartment',
      current_residence_landlord_name: 'Maple Properties',
      current_residence_landlord_phone: '5556667788',
      current_residence_start_date: '2021-02-01T08:00:00.000Z',
      other_residence_rental: false,
      other_residence_address: '',
      other_residence_unit: '',
      other_residence_city: '',
      other_residence_state: '',
      other_residence_zip: '',
      other_residence_rent: '',
      other_residence_reason_for_leaving: '',
      other_residence_landlord_name: '',
      other_residence_landlord_phone: '',
      other_residence_start_date: null,
      emergency_contact_name: 'Linda Smith',
      emergency_contact_phone: '5551112222',
      emergency_contact_relationship: 'Mother',
      emergency_contact2_name: 'Chris Johnson',
      emergency_contact2_phone: '5554443333',
      emergency_contact2_relationship: 'Friend',
      misc_smoker: false,
      misc_marital_status: 'Single',
      misc_addl_info: true,
      misc_has_facebook_profile: false,
      misc_crimes: false,
      misc_crimes_details: '',
      misc_bankruptcy: false,
      misc_bankruptcy_details: '',
      misc_legal_residents: true,
      user: '33445566-ZZYY-3344-ZZYY-334455667788',
      children: [],
      vehicles: [
        {
          make: 'Ford',
          model: 'Fusion',
          year: 2017,
          license_plate: 'JKL321'
        }
      ],
      pets: [
        {
          type: 'Cat',
          breed: 'Siamese',
          name: 'Whiskers'
        }
      ]
    },
    application_group: 'GROUP001',
    desired_apartment: 'A102',
    desired_lease_term: 12,
    desired_move_in_date: '2025-01-15T08:00:00.000Z'
  }
];

export default mockData;
